function klarnaProductAndCartPrice() {
    processKlarnaPrices('.klarna-pdp-container', 'data-klarna-product-price');
    processKlarnaPrices('.totals__klarna', 'data-klarna-cart-price');
    processKlarnaPrices('.c-klarna-price', 'data-klarna-product-card-price');
}

function processKlarnaPrices(containerSelector, priceDataAttribute) {
    const klarnaContainers = document.querySelectorAll(containerSelector);
  
    klarnaContainers.forEach(container => {
        const priceSpan = container.querySelector(`span[${priceDataAttribute}]`);
        const price = parseFloat(priceSpan.getAttribute(priceDataAttribute));
        if (isNaN(price)) return;
  
        const annualInterestRate = 21.9 / 100;
        const monthlyInterestRate = annualInterestRate / 12;
        const numberOfPayments = 36;
  
        const monthlyPayment = calculateMonthlyPayment(price, monthlyInterestRate, numberOfPayments);

        if(priceDataAttribute === 'data-klarna-cart-price') {
            priceSpan.innerHTML = `or Pay <span class="text-semibold">fr. £${monthlyPayment.toFixed(2)}/mo</span>. Select Klarna at checkout.`;
        } else if(priceDataAttribute === 'data-klarna-product-card-price') {
            priceSpan.innerHTML = `<span class="text-semibold">fr. £${monthlyPayment.toFixed(2)}/mo</span>`;
        } else {
            priceSpan.innerHTML = `or Pay <span class="text-semibold">fr. £${monthlyPayment.toFixed(2)}/mo</span>. Select plan with Klarna at checkout.`;
        }
        
        // container.style.display = 'flex';
        container.style.visibility = 'visible';

    });
}

function calculateMonthlyPayment(principal, monthlyInterestRate, numberOfPayments) {
    const x = Math.pow(1 + monthlyInterestRate, numberOfPayments);
    return (principal * x * monthlyInterestRate) / (x - 1);
}

document.addEventListener('DOMContentLoaded', klarnaProductAndCartPrice);